import { isBoolean } from 'lodash';

export default function Toggle({ isToggle }) {
  return (
    isBoolean(isToggle) && (
      <div className={'button__toggle-block custom-button__toggle'}>
        <div
          className={'button__toggle-block custom-button__toggle-block'}
          style={{ transform: `translateX(${isToggle ? 100 : 0}%)` }}
        />
      </div>
    )
  );
}
